module.exports = __webpack_public_path__ + "media/images/index/step3-40aaaf8259e9c7434164a80b145fd6e4.svg";